import { useMutation } from "@tanstack/react-query";
import { SendFormToClientRequest, SendFormToClientResponse } from "@dune/types";
import { privateAxios } from "../axios";

const sendFormToClient = async (
	data: SendFormToClientRequest,
): Promise<SendFormToClientResponse> => {
	const { data: response } = await privateAxios.post<SendFormToClientResponse>(
		"/constructionSites/send-quiz-for-client",
		data,
	);
	return response;
};

export const useSendFormMutation = () => {
	return useMutation({
		mutationFn: sendFormToClient,
		onError: (error) => {
			console.error("Failed to send form:", error);
		},
	});
};
